import classNames from "classnames";
import { Paper, styled } from "@mui/material";

const TablePanel = ({ className, children }) => (
  <Paper className={classNames("table-panel", className)}>{children}</Paper>
);

export default styled(TablePanel)(({ theme }) => ({
  width: "100%",
  ".CinActionBar-root + .MuiTable-root": {
    marginTop: theme.spacing(2),
  },
  ".MuiTable-root + .table-pagination": {
    marginTop: theme.spacing(2),
  },
  ".MuiTableCell-head": {
    fontSize: "1em",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  ".MuiTableRow-root:last-of-type > .MuiTableCell-body": {
    borderBottom: "none",
  },
}));
